export enum CanvasAddEntitySelection {
	Note = 'note',
	Query = 'query',
	Chart = 'chart',
	Grid = 'grid',
	Timeline = 'timeline',
}

export function isCanvasAddReferenceRepositorySelection(value: string): boolean {
	return !Object.values(CanvasAddEntitySelection).includes(value as CanvasAddEntitySelection);
}
